export class MetafieldLogin extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.error?.exists) {
      this.resetError()
    }
  }

  setupListeners () {
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleFormInput = this.handleFormInput.bind(this)

    if (this.els?.form?.element) {
      this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
    }

    if (this.els.error?.exists) {
      this.listeners.add(this.els.form.element, 'input', this.handleFormInput)
    }
  }

  async handleSubmit (event) {
    event.preventDefault()

    const formData = new FormData(this.els.form.element)
    const metafieldLoginCode = formData.get('loginCode')

    if (!metafieldLoginCode) return

    await this.setCartAttribute(this.cartAttributeKey, metafieldLoginCode)

    window.location.reload()
  }

  handleFormInput () {
    if (this.els.error?.exists) {
      this.els.error.element.setAttribute('aria-hidden', true)
    }
  }

  resetError () {
    this.setCartAttribute(this.cartAttributeKey, '')
  }

  setCartAttribute (attributeKey, attributeValue) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }

  get cartAttributeKey () {
    return `entered_login_password`
  }
}

if (!customElements.get('metafield-login')) {
  customElements.define('metafield-login', MetafieldLogin)
}
